import { SVGProps } from 'react';

const ListFilterPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10 18h4M11 6H3m12 0h6m-3 3V3M7 12h8"
    />
  </svg>
);
export default ListFilterPlus;
